import type { ReturnRequestDto, UpdateLineItemDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

interface UseUpdateLineItemParams {
  onSuccess: (returnRequest: ReturnRequestDto) => void;
}

export default function useUpdateLineItem(params: UseUpdateLineItemParams) {
  return useApiMutation(
    "patch",
    "/shops/{shopId}/return-requests/{returnRequestId}/line-items/{lineItemId}",
    {
      onSuccess: (returnRequest: ReturnRequestDto) => {
        params.onSuccess(returnRequest);
      },
      mapVariables: (
        data: {
          shopId: string;
          returnRequestId: string;
          lineItemId: string;
        } & UpdateLineItemDto,
      ) => ({
        params: {
          path: {
            shopId: data.shopId,
            returnRequestId: data.returnRequestId,
            lineItemId: data.lineItemId,
          },
        },
        body: {
          countryOfOrigin: data.countryOfOrigin,
          harmonizedSystemCode: data.harmonizedSystemCode,
          new_variant: data.new_variant,
          resolution: data.resolution,
        },
      }),
    },
  );
}
